<template>

  <div
    class="table-flex"
    :style="{ height: height }">
    <div
      style="overflow: auto;"
      class="mb-2">
      
      <table
        class="table table-bordered">
        <thead>
          <tr>
            <th
              scope="col"
              v-for="(header, index) in dataChart.headers"
              :key="index"
              :class="{ 'text-muted': header.field !== sortBy  }">
                <div @click="changeSort(header.field, sortDirection === 'desc' ? 'asc' : 'desc')">
                  {{ header.name }}
                  <i
                    v-if="header.field === sortBy"
                    class="fas"
                    :class="{ 'fa-chevron-up': sortDirection === 'desc', 'fa-chevron-down': sortDirection === 'asc' }"></i>
                </div>
              </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(doc, docIndex) in dataChart.docs"
            :key="docIndex">
            <td
              v-for="(header, headerIndex) in dataChart.headers"
              :key="headerIndex">
                <div v-if="doc[header.field]">
                  <span
                    v-if="['keyword', 'keyword_text'].includes(doc[header.field].type) && !doc[header.field].url">
                    {{ doc[header.field].value }}
                    </span>
                  <a
                    v-if="['keyword', 'keyword_text'].includes(doc[header.field].type) && doc[header.field].url"
                    :href="doc[header.field].url"
                    target="_blank">
                    {{ doc[header.field].value }}
                    </a>
                  <span
                    v-if="doc[header.field].type === 'boolean'">
                    {{ doc[header.field].value }}
                    </span>
                  <span
                    v-if="doc[header.field].type === 'date' && doc[header.field].value">
                    {{ $d(new Date(doc[header.field].value), doc[header.field].date_format || 'short') }}
                    </span>
                  <span
                    v-if="doc[header.field].type === 'double'">
                    {{ doc[header.field].value }}
                    </span>
                  <span
                    v-if="doc[header.field].type === 'float'">
                    {{ doc[header.field].value }}
                    </span>
                </div>
              </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div class="d-flex flex-row">
        <div class="p-2" v-html="$tc('n_records', dataChart.total, { count: dataChart.total })"></div>
        <div>
          <div class="btn-group" role="group" aria-label="Basic example">
            <button
              type="button"
              class="btn btn-light"
              @click="prevPage"
              :disabled="dataChart.page === 1">
              <i class="fas fa-chevron-left" />
            </button>
            <button
              type="button"
              class="btn btn-light"
              @click="nextPage"
              :disabled="dataChart.page >= Math.ceil(dataChart.total / dataChart.limit)">
              <i class="fas fa-chevron-right" />
            </button>
            <button
              v-if="permissions.includes('manage_settings')"
              type="button"
              class="btn btn-sm btn-light"
              @click="showExport = true" >
              <i class="fas fa-download" />
            </button>
            <Export
              v-if="showExport"
              @close="showExport = false"
              :filters="exportFilters"
              :select="exportSelect"
              :module="exportModule"
              :sort="sortBy"
              :direction="sortDirection" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Export from './Export'
export default {
  name: 'Table',
  components: {
    Export
  },
  props: {
    dataChart: {
      type: Object
    },
    page: {
      type: Number
    },
    sortBy: {
      type: String
    },
    sortDirection: {
      type: String,
      default: 'asc'
    },
    height: {
      type: String,
      default: '320px'
    },
    exportModule: {
      type: String
    },
    exportSelect: {
      type: Array,
      default: () => { return null }
    },
    exportFilters: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      showExport: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    }
  },
  created () {
  },
  methods: {
    prevPage () {
      this.$emit('changePage', this.page - 1)
    },
    nextPage () {
      this.$emit('changePage', this.page + 1)
    },
    changeSort (sortBy, sortDirection) {
      this.$emit('sort', { sortBy, sortDirection })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-flex {
  display: flex;
  flex-direction: column;
}

.table {
  border-top: 0;
}
  .table > thead {
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: 0;
    background: #ffffff;
  }
  .table > thead th {
    border-top: 0;
    border-bottom: 0; 
    padding: 0;
  }
  .table > thead th div {
    border-top: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
    white-space: nowrap;
    padding: 10px;
    cursor: pointer;
  }
  .table > tbody > tr > td {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/Table.vue